// import { takeEvery, takeLatest, all } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';

// Import all ActionTypes
import { Types } from './actions';

// Import all Sagas
import {
  fetchBannerSaga,
  fetchRecentNewsSaga,
  fetchTrendingTagsSaga,
  fetchTopNewsSaga,
  increasePostCountSaga
} from '../app/news/duck';

import {
  fetchSingleNewsSaga,
  fetchRelatedArticlesForSingleNewsSaga
} from '../app/single-article/single-news/duck';

import {
  fetchReviewsBannerSaga,
  fetchLatestReviewsSaga,
  fetchTopReviewsSaga,
  fetchAccessoriesSaga,
  fetchCamerasSaga,
  fetchMobilesSaga,
  fetchLaptopsSaga,
  fetchBestOfLaptopsSaga,
  fetchBestOfMobilesSaga,
  fetchBestOfCamerasSaga,
  fetchBestOfAccessoriesSaga,
  fetchLaptopsReviewsSaga,
  fetchMobilesReviewsSaga,
  fetchCamerasReviewsSaga,
  fetchAccessoriesReviewsSaga
} from '../app/reviews/duck';

import {
  fetchSingleReviewSaga,
  fetchRelatedArticlesForSingleReviewSaga
} from '../app/single-article/single-review/duck';

import { fetchT3BannerSaga, fetchLatestT3Saga } from '../app/how-to-(T3)/duck';
import {
  fetchTopPicksSaga,
  fetchSingleT3Saga,
  fetchBestSoftwaresSaga,
  fetchRelatedArticlesForSingleT3Saga
} from '../app/single-article/single-t3/duck';
import {
  fetchInternetBannerSaga,
  fetchLatestInternetSaga
} from '../app/internet/duck';
// import {
//   fetchBestOfBannerSaga,
//   fetchBestOfLatestReviewsSaga
// } from '../app/best-of/duck';
// import {
//   fetchSingleBestOfSaga,
//   fetchRelatedProductsSaga,
//   fetchRelatedArticlesForSingleBestOfSaga
// } from '../app/single-article/single-best-of/duck';

import { fetchAuthorInfoSaga, fetchAuthorPostsSaga } from '../app/author/duck';
import { fetchTagsPostListSaga } from '../app/tags/duck';
import {
  fetchHomeBannerSaga,
  fetchLatestSaga,
  fetchTrendingSaga,
  fetchReviewsSaga
} from '../app/home/duck';

import {
  fetchGallerySaga,
  fetchOldGallerySaga
} from '../app/gallery/duck/sagas';
import {
  fetchTopResultsSaga,
  fetchTopReviewsForSearchSaga
} from '../app/common/Search/duck';

export function* watchNews() {
  // yield all(
  //   takeLatest(Types.FETCH_BANNER, fetchBannerSaga),
  //   takeLatest(Types.FETCH_RECENT_NEWS, fetchRecentNewsSaga),
  //   takeLatest(Types.FETCH_TRENDING_TAGS, fetchTrendingTagsSaga)
  // );

  yield takeLatest(Types.FETCH_BANNER, fetchBannerSaga);
  yield takeLatest(Types.FETCH_RECENT_NEWS, fetchRecentNewsSaga);
  yield takeLatest(Types.FETCH_TRENDING_TAGS, fetchTrendingTagsSaga);
  yield takeLatest(Types.FETCH_TOP_NEWS, fetchTopNewsSaga);
  yield takeLatest(Types.INCREASE_POST_COUNT, increasePostCountSaga);

  // yield takeEvery(Types.FETCH_BANNER, fetchBannerSaga);
  // yield takeEvery(Types.FETCH_RECENT_NEWS, fetchRecentNewsSaga);
  // yield takeEvery(Types.FETCH_TRENDING_TAGS, fetchTrendingTagsSaga);
}

export function* watchSingleNews() {
  yield takeLatest(Types.FETCH_SINGLE_NEWS, fetchSingleNewsSaga);
  yield takeLatest(
    Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_NEWS,
    fetchRelatedArticlesForSingleNewsSaga
  );
}

export function* watchReviews() {
  yield takeLatest(Types.FETCH_REVIEWS_BANNER, fetchReviewsBannerSaga);
  yield takeLatest(Types.FETCH_LATEST_REVIEWS, fetchLatestReviewsSaga);
  yield takeLatest(Types.FETCH_TOP_REVIEWS, fetchTopReviewsSaga);
  yield takeLatest(Types.FETCH_LAPTOPS, fetchLaptopsSaga);
  yield takeLatest(Types.FETCH_MOBILES, fetchMobilesSaga);
  yield takeLatest(Types.FETCH_CAMERAS, fetchCamerasSaga);
  yield takeLatest(Types.FETCH_ACCESSORIES, fetchAccessoriesSaga);
  yield takeLatest(Types.FETCH_BEST_OF_LAPTOPS, fetchBestOfLaptopsSaga);
  yield takeLatest(Types.FETCH_BEST_OF_MOBILES, fetchBestOfMobilesSaga);
  yield takeLatest(Types.FETCH_BEST_OF_CAMERAS, fetchBestOfCamerasSaga);
  yield takeLatest(Types.FETCH_BEST_OF_ACCESSORIES, fetchBestOfAccessoriesSaga);
  yield takeLatest(Types.FETCH_LAPTOPS_REVIEWS, fetchLaptopsReviewsSaga);
  yield takeLatest(Types.FETCH_MOBILES_REVIEWS, fetchMobilesReviewsSaga);
  yield takeLatest(Types.FETCH_CAMERAS_REVIEWS, fetchCamerasReviewsSaga);
  yield takeLatest(
    Types.FETCH_ACCESSORIES_REVIEWS,
    fetchAccessoriesReviewsSaga
  );
}

export function* watchSingleReview() {
  yield takeLatest(Types.FETCH_SINGLE_REVIEW, fetchSingleReviewSaga);
  yield takeLatest(
    Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_REVIEW,
    fetchRelatedArticlesForSingleReviewSaga
  );
}

export function* watchT3() {
  yield takeLatest(Types.FETCH_T3_BANNER, fetchT3BannerSaga);
  yield takeLatest(Types.FETCH_LATEST_T3, fetchLatestT3Saga);
}

export function* watchSingleT3() {
  yield takeLatest(Types.FETCH_SINGLE_T3, fetchSingleT3Saga);
  yield takeLatest(Types.FETCH_TOP_PICKS, fetchTopPicksSaga);
  yield takeLatest(
    Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_T3,
    fetchRelatedArticlesForSingleT3Saga
  );
  yield takeLatest(Types.FETCH_BEST_SOFTWARES, fetchBestSoftwaresSaga);
}

export function* watchInternet() {
  yield takeLatest(Types.FETCH_INTERNET_BANNER, fetchInternetBannerSaga);
  yield takeLatest(Types.FETCH_LATEST_INTERNET, fetchLatestInternetSaga);
}

// export function* watchBestOf() {
//   yield takeLatest(Types.FETCH_BEST_OF_BANNER, fetchBestOfBannerSaga);
//   yield takeLatest(
//     Types.FETCH_BEST_OF_LATEST_REVIEWS,
//     fetchBestOfLatestReviewsSaga
//   );
//   yield takeLatest(Types.FETCH_TOP_REVIEWS, fetchTopReviewsSaga);
//   yield takeLatest(Types.FETCH_LAPTOPS, fetchLaptopsSaga);
//   yield takeLatest(Types.FETCH_MOBILES, fetchMobilesSaga);
//   yield takeLatest(Types.FETCH_CAMERAS, fetchCamerasSaga);
//   yield takeLatest(Types.FETCH_ACCESSORIES, fetchAccessoriesSaga);
//   yield takeLatest(Types.FETCH_BEST_OF_LAPTOPS, fetchBestOfLaptopsSaga);
//   yield takeLatest(Types.FETCH_BEST_OF_MOBILES, fetchBestOfMobilesSaga);
//   yield takeLatest(Types.FETCH_BEST_OF_CAMERAS, fetchBestOfCamerasSaga);
//   yield takeLatest(Types.FETCH_BEST_OF_ACCESSORIES, fetchBestOfAccessoriesSaga);
//   yield takeLatest(Types.FETCH_LAPTOPS_REVIEWS, fetchLaptopsReviewsSaga);
//   yield takeLatest(Types.FETCH_MOBILES_REVIEWS, fetchMobilesReviewsSaga);
//   yield takeLatest(Types.FETCH_CAMERAS_REVIEWS, fetchCamerasReviewsSaga);
//   yield takeLatest(
//     Types.FETCH_ACCESSORIES_REVIEWS,
//     fetchAccessoriesReviewsSaga
//   );
// }
// export function* watchSingleBestOf() {
//   yield takeLatest(Types.FETCH_SINGLE_BEST_OF, fetchSingleBestOfSaga);
//   yield takeLatest(Types.FETCH_RELATED_PRODUCTS, fetchRelatedProductsSaga);
//   yield takeLatest(
//     Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_BEST_OF,
//     fetchRelatedArticlesForSingleBestOfSaga
//   );
//   yield takeLatest(Types.FETCH_BEST_SOFTWARES, fetchBestSoftwaresSaga);
// }

export function* watchAuthorInfo() {
  yield takeLatest(Types.FETCH_AUTHOR_INFO, fetchAuthorInfoSaga);
  yield takeLatest(Types.FETCH_AUTHOR_POSTS, fetchAuthorPostsSaga);
}

export function* watchTagsPostList() {
  yield takeLatest(Types.FETCH_TAGS_POST_LIST, fetchTagsPostListSaga);
}

export function* watchHome() {
  yield takeLatest(Types.FETCH_HOME_BANNER, fetchHomeBannerSaga);
  yield takeLatest(Types.FETCH_LATEST, fetchLatestSaga);
  yield takeLatest(Types.FETCH_TRENDING, fetchTrendingSaga);
  yield takeLatest(Types.FETCH_REVIEWS, fetchReviewsSaga);
  // yield takeLatest(Types.INCREASE_POST_COUNT, increasePostCountSaga);
}

export function* watchGallery() {
  yield takeLatest(Types.FETCH_GALLERY, fetchGallerySaga);
  yield takeLatest(Types.FETCH_OLD_GALLERY, fetchOldGallerySaga);
}

export function* watchSearch() {
  // yield takeLatest(Types.FETCH_GALLERY, fetchGallerySaga);
  yield takeLatest(Types.FETCH_TOP_RESULTS, fetchTopResultsSaga);
  yield takeLatest(
    Types.FETCH_TOP_REVIEWS_FOR_SEARCH,
    fetchTopReviewsForSearchSaga
  );
}

// console.log('Types: ', Types);
